module.exports = __webpack_public_path__ + "img/ez-slot-category-popular-mobile.a4d11984.png";